import {differenceInDays} from 'date-fns';

import {isEmpty, isNil} from 'ramda';

import {parseDate} from 'shared/web';

/**
 * Price-map "sold 31–90 days ago" band — occurrence-based only.
 * Vehicles sold within 30 days are handled by `isSoldIn30Days`.
 * The backend filters out vehicles sold more than 90 days ago.
 * Live `just_sold` does not encode sold duration, so it must not influence this band.
 */
export function isSoldIn90Days(car: {is_sold: boolean | null; last_occurrence: string | null}) {
  if (isNil(car.last_occurrence) || isEmpty(car.last_occurrence)) {
    return false;
  }
  return !!car.is_sold && differenceInDays(new Date(), parseDate(car.last_occurrence)) > 30;
}
